import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { showErrorToast, showSuccessToast ,showWarningToast} from '../../utils/toastUtils';
import { verifyEmailOtp } from '../../Services/profile/profileservice';

const PinInput = ({ inputRefs, onPinChange,onSubmit }) => {
  const [pin, setPin] = useState(['', '', '', '', '', '']);

  const handleChange = (index, value) => {
    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

 const fullPin = newPin.join('');
    if (onPinChange) onPinChange(fullPin);

    // Move focus to next input
    if (value !== '' && index < 5) inputRefs.current[index + 1].current.focus();

    // Auto-submit when 6 digits are entered
    if (fullPin.length === 6 && onSubmit) {
      onSubmit(fullPin); // pass fullPin directly
    }
  };

  const handleBackspace = (index, event) => {
    if (event.key === 'Backspace' && index > 0 && pin[index] === '') {
      inputRefs.current[index - 1].current.focus();
    }
  };


  return (
    <div className="flex justify-center mb-4">
      {pin.map((value, index) => (
        <React.Fragment key={index}>
          <input
            ref={inputRefs.current[index]}
            type="password"
            maxLength={1}
            value={value}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleBackspace(index, e)}
            className="border border-blue-500 md:w-10 md:h-10 w-9 h-10 text-center mx-1 rounded shadow-lg shadow-blue-600"
            autoFocus={index === 0}
          />
          {index === 2 && <span className="mt-2 text-sky-500 ml-1">&ndash;</span>}
        </React.Fragment>
      ))}
    </div>
  );
};




const ModalWithPinInputEmail = ({ isModalOpen, toggleModalEmail, title, identifier,onLoadReport  }) => {
  const inputRefs = useRef(Array.from({ length: 6 }).map(() => React.createRef()));
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();


  const handleSubmit = async (currentOtp = pin) => {
  if (currentOtp.length !== 6) {
    setError("Please enter the 6-digit OTP");
    return;
  }

  if (!identifier) {
    setError("Identifier is missing");
    return;
  }

  try {
    setError(""); 

    const response = await verifyEmailOtp({
      identifier: identifier,
      otp: currentOtp
    });

    const statusCode = response?.status?.code;

    // ✅ 200 — Success
    if (statusCode === 200) {
      showSuccessToast(response?.status?.message || "Email verified successfully");
      toggleModalEmail(); 
      setPin("");      
      onLoadReport();
      return;
    }

    // ❌ 400 — OTP invalid / expired
    if (statusCode === 400) {
      const errorMessage = response?.message || "OTP verification failed";
      setError(errorMessage);      // inline under PIN
      showErrorToast(errorMessage);
      return;
    }

    // ❌ 422 — other validation errors
    if (statusCode === 422) {
      const errorMessage = response?.message || "Invalid OTP";
      setError(errorMessage);
      showErrorToast(errorMessage);
      return;
    }

    // ❌ 500 — Server error
    if (statusCode === 500) {
      const serverMessage = response?.message || "Server error, please try again";
      setError(serverMessage);
      showErrorToast(serverMessage);
      return;
    }

    // ⚠️ fallback
    setError("Unexpected response from server");
    showWarningToast("Unexpected response from server");

  } catch (err) {
    console.error("Email OTP verification error:", err);
    setError("Failed to verify OTP. Please try again.");
    showErrorToast("Failed to verify OTP. Please try again.");
  }
};


  return (
    isModalOpen && (

      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" style={{ zIndex:9999}}>
        <div className="bg-white rounded-lg shadow-lg w-11/12 md:w-1/3">
          <div className="bg-[#130092] text-white text-center py-4 rounded-t-lg">
            <span className="text-xl">{title}</span>
          </div>
          <div className="p-4">
            <PinInput inputRefs={inputRefs} onPinChange={setPin}  onSubmit={handleSubmit}/>
            {error && <div className="text-red-500 mt-2 text-center">{error}</div>}
          </div>
          <div className="flex justify-between p-6">
            <button
              type="button"
              className="bg-red-900 shadow-xl shadow-red-600 bg-gradient-to-r from-red-400 to-red-900 text-white text-xl py-0 px-2 rounded-md hover:from-red-900 hover:to-red-400 focus:outline-none"
              onClick={toggleModalEmail}
            >
              Close
            </button>
            <button
              type="button"
              className="text-center text-white bg-blue-900 shadow-xl hidden shadow-blue-600  bg-gradient-to-r from-blue-400 to-blue-900 font-semibold rounded-md px-2 py-0 text-xl hover:from-blue-900 hover:to-blue-400 border-1"
               onClick={() => handleSubmit()} 
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default ModalWithPinInputEmail;

